export default __webpack_public_path__ + "static/media/privacy_policy.78683f1f.pdf";